/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {PresetRolesRequest} from '../models/PresetRolesRequest';
import type {PresetRolesResponse} from '../models/PresetRolesResponse';

export interface AssignRoles$Request {
    presetRolesRequest: PresetRolesRequest;
}

export interface AssignRoles$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const assignRolesRequest = createAction<PayloadData<void, AssignRoles$Request>>('BULK_ASSIGN_PRESET_ROLES__ASSIGN_ROLES__REQUEST');
export const assignRolesSuccess = createAction<PayloadData<string, AssignRoles$Request>>('BULK_ASSIGN_PRESET_ROLES__ASSIGN_ROLES__SUCCESS');
export const assignRolesFailure = createAction<PayloadData<Error, AssignRoles$Request, true>>('BULK_ASSIGN_PRESET_ROLES__ASSIGN_ROLES__FAILURE');

export const assignRolesActions = [
    assignRolesRequest,
    assignRolesSuccess,
    assignRolesFailure
] as const;

/**
 * @param {PresetRolesRequest} meta.presetRolesRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const assignRoles = (meta: AssignRoles$Request, config?: AssignRoles$Config) => {
    return {
        CALL_API: {
            types: assignRolesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/presets/assign-roles`,
            TRANSPORT_REQUEST_BODY: meta.presetRolesRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface BulkAssignPresetRolesProgress$Request {
    id: string;
}

export interface BulkAssignPresetRolesProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkAssignPresetRolesProgressRequest = createAction<PayloadData<void, BulkAssignPresetRolesProgress$Request>>('BULK_ASSIGN_PRESET_ROLES__BULK_ASSIGN_PRESET_ROLES_PROGRESS__REQUEST');
export const bulkAssignPresetRolesProgressSuccess = createAction<PayloadData<BulkProgress, BulkAssignPresetRolesProgress$Request>>('BULK_ASSIGN_PRESET_ROLES__BULK_ASSIGN_PRESET_ROLES_PROGRESS__SUCCESS');
export const bulkAssignPresetRolesProgressFailure = createAction<PayloadData<Error, BulkAssignPresetRolesProgress$Request, true>>('BULK_ASSIGN_PRESET_ROLES__BULK_ASSIGN_PRESET_ROLES_PROGRESS__FAILURE');

export const bulkAssignPresetRolesProgressActions = [
    bulkAssignPresetRolesProgressRequest,
    bulkAssignPresetRolesProgressSuccess,
    bulkAssignPresetRolesProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkAssignPresetRolesProgress = (meta: BulkAssignPresetRolesProgress$Request, config?: BulkAssignPresetRolesProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: bulkAssignPresetRolesProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/presets/assign-roles/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignRolesResult$Request {
    id: string;
}

export interface GetAssignRolesResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignRolesResultRequest = createAction<PayloadData<void, GetAssignRolesResult$Request>>('BULK_ASSIGN_PRESET_ROLES__GET_ASSIGN_ROLES_RESULT__REQUEST');
export const getAssignRolesResultSuccess = createAction<PayloadData<PresetRolesResponse, GetAssignRolesResult$Request>>('BULK_ASSIGN_PRESET_ROLES__GET_ASSIGN_ROLES_RESULT__SUCCESS');
export const getAssignRolesResultFailure = createAction<PayloadData<Error, GetAssignRolesResult$Request, true>>('BULK_ASSIGN_PRESET_ROLES__GET_ASSIGN_ROLES_RESULT__FAILURE');

export const getAssignRolesResultActions = [
    getAssignRolesResultRequest,
    getAssignRolesResultSuccess,
    getAssignRolesResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignRolesResult = (meta: GetAssignRolesResult$Request, config?: GetAssignRolesResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignRolesResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/presets/assign-roles`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

